class VoucherRecord {
	summary: string;
	subject: any;
	foresubText: string;
	subjectId: number | null;
	jfmoney: number | string;
	dfmoney: number | string;
	measuringUnit: string | null;
	currSymbol: string | null;
	jfmoneyOrg: number;
	dfmoneyOrg: number;
	org: number;
	jfnumber: number;
	dfnumber: number;
	number: number;
	exchangeRate: number;
	unitPrice: number;
	dimAccountType: string | null;
	assistantAccountId: number | null;
	assist: any;
	relation: any;
	assistList: any;
	constructor() {
		this.summary = "";
		this.subject = {};
		this.foresubText = "";
		this.subjectId = null;
		this.jfmoney = "";
		this.dfmoney = "";
		this.measuringUnit = null;
		this.currSymbol = null;
		this.jfmoneyOrg = 0;
		this.dfmoneyOrg = 0;
		this.org = 0;
		this.jfnumber = 0;
		this.dfnumber = 0;
		this.number = 0;
		this.exchangeRate = 0;
		this.unitPrice = 0;
		this.dimAccountType = null;
		this.assistantAccountId = null;
		this.assist = null;
		this.relation = null;
		this.assistList = {};
	}
}

// let defaultRecords = {
//     rows: [new VoucherRecord(), new VoucherRecord(), new VoucherRecord(), new VoucherRecord(), new VoucherRecord()],
//     one: new VoucherRecord()
// }

class defaultRecords {
	one: VoucherRecord;
	rows: VoucherRecord[];
	constructor() {
		this.one = new VoucherRecord();
		this.rows = [new VoucherRecord(), new VoucherRecord(), new VoucherRecord(), new VoucherRecord(), new VoucherRecord()]
	}
}

export default defaultRecords;
